import { applyFilters } from '@wordpress/hooks';
import GeneralInput from "./GeneralInput";
import TextareaInput from './TextareaInput';
import SelectInput from './SelectInput';
import ColorInput from './ColorInput';
import NumberInput from './NumberInput';
import SwitchInput from './SwitchInput';
import CheckboxInput from './CheckboxInput';
import RadioInput from './RadioInput';
import TitleInput from './TitleInput';

const getInput = ( type ) => {
	switch( type ) {
		case 'textarea':
			return TextareaInput;
		case 'select':
			return SelectInput;
		case 'color':
			return ColorInput;
		case 'number':
			return NumberInput;
		case 'switch':
			return SwitchInput;
		case 'checkbox':
			return CheckboxInput;
		case 'radio':
			return RadioInput;
		case 'title':
			return TitleInput;
	}

	return GeneralInput;
}

export default ( type ) => {
	return applyFilters( 'options-kit/input', getInput( type ), type );
}